import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=132bf5dc&scoped=true&"
import script from "./OrderIndex.vue?vue&type=script&lang=js&"
export * from "./OrderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132bf5dc",
  null
  
)

export default component.exports